export enum HideNewsLikes {
  Hide = 'Hide',
  HideIfNoLikes = 'HideIfNoLikes',
}
